import { createFileRoute } from '@tanstack/react-router';
import { FluxoPage, lerBuscaFluxo, mesAtual } from '@/components/plano';
import { periodoPadraoFluxo } from '@/components/plano/fluxo-busca';

export const Route = createFileRoute('/_app/plano/fluxo')({
  validateSearch: (bruto: Record<string, unknown>) => lerBuscaFluxo(bruto),
  component: FluxoRota,
});

function FluxoRota() {
  const busca = Route.useSearch();
  const padrao = periodoPadraoFluxo(mesAtual());
  return <FluxoPage de={busca.de ?? padrao.de} ate={busca.ate ?? padrao.ate} granularidade={busca.granularidade ?? 'semana'} />;
}
